import * as dompurify from 'dompurify'

declare global {
  // tslint:disable-next-line: no-any
  var __STATIC_URL_POLICY__: any
}

export const applyDefaultPolicy = () => {
  if (window.trustedTypes && window.trustedTypes.createPolicy) {
    window.trustedTypes.createPolicy('default', {
      // @ts-ignore
      createHTML: (html: string) => dompurify.sanitize(html, { RETURN_TRUSTED_TYPE: true }),
      createScriptURL: (src: string) => src,
    })
  }
}

export const applyScriptUrlPolicy = () => {
  if (window.trustedTypes && window.trustedTypes.createPolicy) {
    window.__STATIC_URL_POLICY__ = window.trustedTypes.createPolicy(
      'static-js-url',
      { createScriptURL: (src: string) => src }) // add logic to trust only few domains
  }
}
